var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaf = function SvgLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.572 4.869a7.124 7.124 0 0 0-13.144 0A6.78 6.78 0 0 0 .5 10.98c-.01 3.64 2.94 6.675 6.576 6.769a6.7 6.7 0 0 0 3.174-.704v3.704a.75.75 0 1 0 1.5 0v-3.704a6.7 6.7 0 0 0 3 .704h.174c3.636-.094 6.586-3.128 6.576-6.767a6.78 6.78 0 0 0-3.928-6.114m-2.686 11.38a5.2 5.2 0 0 1-3.049-.88l-.087-.054v-3.852l4.086-2.042a.751.751 0 0 0-.672-1.342L11.75 9.787V7.25a.75.75 0 1 0-1.5 0v4.787l-3.414-1.708a.75.75 0 0 0-.672 1.342l4.086 2.042v1.6q-.044.024-.087.053a5.25 5.25 0 1 1-5.111-9.134c.34-.156.61-.435.754-.781a5.625 5.625 0 0 1 10.378 0c.145.346.414.625.755.78a5.25 5.25 0 0 1-2.062 10.019z"
  })));
};
export default SvgLeaf;